import DataAssetLoader from '@sparta.global.utilities/data-asset-loader-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import SpartaSingletonUtility from '@sparta.global.utilities/sparta-singleton-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import MessagingDefaultsUtility from '@sparta.global.utilities/messaging-defaults-utility/dist/es6.js';
import { messagingHelper } from '@sparta.global.helpers/messaging-helper/dist/es6.js';

/* eslint-disable require-jsdoc */

function insertPositionInOptions(options, insert) {
  return {
    ...options,
    insert
  };
}
class spartaMessageUtility {
  constructor(settings = {}) {
    // Get default options and UUID from utility call or create one
    const options = MessagingDefaultsUtility.getDefaultConfig();
    options.uuid = settings.uuid || ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);

    // Merge options to make sure we have a unique options on each message creation.
    this._options = Object.assign({}, options);

    // set a default type
    this._type = 'info';

    // get current language
    this._options.language = spartaStoreUtility.getData('jcrLang');

    // Determine if we've been given a Uuid and if its a DOM element or string
    settings.uuid = this.getUuidValue(settings.uuid);

    // If utility instance was created from helper, lets update some of the default globals:
    const msgInstanceElm = document.getElementById(`sparta-message-${settings.uuid}`);
    if (msgInstanceElm && msgInstanceElm.hasAttribute('data-options')) {
      const elmParams = JSON.parse(msgInstanceElm.getAttribute('data-options'));
      this._type = elmParams.type;
      this._title = elmParams.title;
      this._message = elmParams.content;
      this._target = msgInstanceElm;
      this._options = elmParams.options;
      this._options.uuid = elmParams.uuid;

      // Add listener and callback.
      this.addListeners();
      this.addCallback();

      // Remove data attributes from helper-created utility item
      msgInstanceElm.removeAttribute('data-options');
    }

    // Update global params
    this._globalReadyToken = spartaEventsUtility.sub('SPARTA_GLOBAL_READY.spartaBootstrapUtility', () => {
      this.setGlobalStrings();
    }, true);
  }
  getUuidValue(uuid) {
    if (!uuid) {
      return false;
    }

    // Set empty default.
    let uniqueID = '';

    // Determine if we've been given a Uuid and if its a DOM element or string
    uniqueID = typeof uuid === 'string' ? uuid : uuid.id;

    // See if we need to remove the shared helper part of the string
    uniqueID = uniqueID.includes('sparta-message-') ? uniqueID.replace('sparta-message-', '') : uniqueID;
    return uniqueID;
  }
  init() {
    return this;
  }
  title(title) {
    this._title = title || '';
    return this;
  }
  message(msg) {
    this._message = msg || '';
    return this;
  }
  type(type) {
    if (type) {
      this._type = type;
    }
    return this;
  }
  show(target, localOptions = {}) {
    this._target = target;
    let template;

    // grab and merge options
    const opts = {
      ...this._options,
      ...localOptions
    };
    this._options = opts;
    if (!opts.neverShow || !opts.remind) {
      if (!this.importTriggered) {
        this.loadMessageIcons().then(xhr => {
          this.dismissADALabel = xhr.dismissADALabel;
          this.dismissMessage = xhr.dismissMessage;
          this.messageIconText = xhr.messageIconText;
          this.importTriggered = true;

          // make html template
          template = this.buildTemplate();

          // insert into dom
          this.attach(template);
          this.addListeners();
        });
      } else {
        // make html template
        template = this.buildTemplate();

        // insert into dom
        this.attach(template);
        this.addListeners();
      }
    }
    return this;
  }
  buildTemplate() {
    return `${messagingHelper({
      uuid: this._options.uuid,
      title: this._title,
      content: this._message,
      type: this._type,
      options: this._options
    })}`;
  }
  formatMessage() {
    const message = this._message;
    const settings = this._options;
    return `${messagingFormatHelper({
      message,
      settings
    })}`;
  }
  destroy() {
    const {
      uuid
    } = this._options;
    if (!uuid) return false;
    const id = `sparta-message-${uuid}`;
    const element = document.getElementById(id);
    if (element) {
      element.parentNode.removeChild(element);
    }
    return false;
  }
  attach(template) {
    const el = this._target instanceof Element ? this._target : document.querySelector(this._target);

    // Kill check
    if (!el) {
      return false;
    }
    switch (this._options.insert) {
      case 'before':
        el.insertAdjacentHTML('beforebegin', template);
        break;
      case 'after':
        el.insertAdjacentHTML('afterend', template);
        break;
      case 'insideFirst':
      case 'prepend':
        el.insertAdjacentHTML('afterbegin', template);
        break;
      case 'insideLast':
      case 'append':
        el.insertAdjacentHTML('beforeend', template);
        break;
      case 'replace':
      default:
        el.innerHTML = template;
    }
  }
  loadMessageIcons() {
    const lang = spartaStoreUtility.getData('jcrLang');

    // generate a new DataAssetLoader instance
    const messagingAssetLoader = new DataAssetLoader('@sparta.global.utilities/sparta-messaging-utility', `data/${lang}`);

    // load the relevant messages JSON file, which triggers success and failure
    // events so that the utility can subscribe to them
    const load = messagingAssetLoader.loadAsset('messaging.json');

    // generate a promise with the results from our event subscription so we can
    // return the name of the file that was actually loaded
    // this serves mostly as an example of how to deal with this
    const assetLoaderPromise = new Promise(resolve => {
      // subscribe to the event emitted by the DataAssetLoader
      // we use true for the retroactive parameter to make sure that even if we miss
      // the initial event firing due to it happening quicker than expected, we can
      // still respond to it
      spartaEventsUtility.sub(load.success, evtData => {
        // define the messageList object from the messages.json file
        resolve(evtData.data.xhr);
      }, true);
    });
    spartaEventsUtility.sub(load.failure, evtData => {
      // log out an error for debugging the issue
      if (window.console && console.warn) {
        console.warn(`Sparta Messaging: ${evtData.data.filename} AJAX Error.`, evtData.data.xhr);
      }
    }, true);
    return assetLoaderPromise;
  }
  addCallback() {
    const settings = this;
    spartaEventsUtility.pub(`spartaMessagingUtility.Message_Callback:${settings._options.uuid}`, {
      settings
    });
  }
  addListeners() {
    if (this._options.dismiss) {
      const closeIconSelector = `[id="sparta-message-${this._options.uuid}"] .spartaMessage-close-x`;
      const closeIcon = document.querySelector(closeIconSelector);
      if (closeIcon) {
        closeIcon.addEventListener('click', this.close);
      }
    }
  }
  setGlobalStrings() {
    const spaParams = spartaStoreUtility.getData('spaParams').global[this._options.language];
    const globalJs = spaParams.globalJs;
    this._options.spaParamsIcons = spaParams.messageIconText;

    // Replace strings based on pre-provided JCR value.
    if (!this._options.closeText) {
      this._options.closeText = globalJs.closeText;
    }
    if (!this._options.closeMessageADAText) {
      this._options.closeMessageADAText = globalJs.closeMessageADAText;
    }
    const messageSelector = document.querySelector(`[id="sparta-message-${this._options.uuid}"]`);
    if (messageSelector) {
      // Get strings
      const iconName = this._options.spaParamsIcons[this._type];
      const closeText = this._options.closeText;
      const closeMessageADAText = this._options.closeMessageADAText;

      // Update generic icon
      const messageIcon = messageSelector.querySelector('.spartaMessage-icon .ada-hidden');
      if (messageIcon) {
        messageIcon.innerHTML = iconName;
      }

      // Update dismissible icon
      const messageDismissible = messageSelector.querySelector('.spartaMessage-dismiss .spartaMessage-close-msg');
      if (messageDismissible) {
        messageDismissible.innerHTML = `${closeText} ${iconName} ${closeMessageADAText}`;
      }
    }
  }
  close(evt) {
    evt.preventDefault();
    const element = evt.target.closest('.spartaMessage');
    element.parentNode.removeChild(element);
    return false;
  }

  /*
   *=======================
   *  Shorthand Methods for Developers
   *=======================
   */

  showWithProvidedData(target, {
    type,
    title,
    message,
    options
  }) {
    this._type = type;
    this._title = title;
    this._message = message;
    this.options = options;
    return this.show(target, options);
  }
  showMessage(target, type, title, message, options = {}) {
    const data = {
      type,
      title,
      message,
      options
    };
    return this.showWithProvidedData(target, data);
  }
  showBefore(target, options = {}) {
    options.insert = 'before';
    return this.show(target, options);
  }
  showAfter(target, options = {}) {
    options.insert = 'after';
    return this.show(target, options);
  }
  prepend(target, options = {}) {
    options.insert = 'prepend';
    return this.show(target, options);
  }
  showInsideFirst(target, options = {}) {
    return this.prepend(target, options);
  }
  append(target, options = {}) {
    options.insert = 'insideLast';
    return this.show(target, options);
  }
  showInsideLast(target, options = {}) {
    return this.append(target, options);
  }
  showErrorMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'error', title, message, options);
  }
  showErrorMessageBefore(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }
  showErrorMessageAfter(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }
  showErrorMessageInsideFirst(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }
  showErrorMessageInsideLast(target, title, message, options = {}) {
    return this.showErrorMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
  showSuccessMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'success', title, message, options);
  }
  showSuccessMessageBefore(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }
  showSuccessMessageAfter(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }
  showSuccessMessageInsideFirst(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }
  showSuccessMessageInsideLast(target, title, message, options = {}) {
    return this.showSuccessMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
  showWarningMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'warning', title, message, options);
  }
  showWarningMessageBefore(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }
  showWarningMessageAfter(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }
  showWarningMessageInsideFirst(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }
  showWarningMessageInsideLast(target, title, message, options = {}) {
    return this.showWarningMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
  showInfoMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'info', title, message, options);
  }
  showInfoMessageBefore(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }
  showInfoMessageAfter(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }
  showInfoMessageInsideFirst(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }
  showInfoMessageInsideLast(target, title, message, options = {}) {
    return this.showInfoMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
  showHelpMessage(target, title, message, options = {}) {
    return this.showMessage(target, 'help', title, message, options);
  }
  showHelpMessageBefore(target, title, message, options = {}) {
    return this.showHelpMessage(target, title, message, insertPositionInOptions(options, 'before'));
  }
  showHelpMessageAfter(target, title, message, options = {}) {
    return this.showHelpMessage(target, title, message, insertPositionInOptions(options, 'after'));
  }
  showHelpMessageInsideFirst(target, title, message, options = {}) {
    return this.showHelpMessage(target, title, message, insertPositionInOptions(options, 'prepend'));
  }
  showHelpMessageInsideLast(target, title, message, options = {}) {
    return this.showHelpMessage(target, title, message, insertPositionInOptions(options, 'append'));
  }
}
SpartaSingletonUtility('SpartaMessagingUtility', spartaMessageUtility);

export { spartaMessageUtility as default };
